import ViewData from './ViewData';

export default ViewData;
